declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'set',
      targetOrName: string | Date,
      params?: Record<string, unknown>,
    ) => void;
    dataLayer: Array<unknown>;
  }
}

const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID ?? '';

export function isAnalyticsEnabled(): boolean {
  return GA4_MEASUREMENT_ID.length > 0 && typeof window !== 'undefined';
}

function gtag(
  command: 'config' | 'event' | 'js' | 'set',
  targetOrName: string | Date,
  params?: Record<string, unknown>,
): void {
  if (!isAnalyticsEnabled()) return;
  window.gtag(command, targetOrName, params);
}

// Page views (called on route changes)
export function trackPageView(path: string, title?: string): void {
  gtag('config', GA4_MEASUREMENT_ID, {
    page_path: path,
    page_title: title,
  });
}

// Generic event (escape hatch for one-off events)
export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  gtag('event', eventName, params);
}

// -- Signup CTAs --

export function trackSignupClick(
  tier: 'free' | 'pro',
  billingCycle: 'monthly' | 'annual',
): void {
  trackEvent('signup_click', {
    event_category: 'conversion',
    event_label: `${tier}_${billingCycle}`,
    tier,
    billing_cycle: billingCycle,
  });
}

// -- Pricing --

export function trackPricingToggle(plan: 'monthly' | 'annual'): void {
  trackEvent('pricing_toggle', {
    event_category: 'engagement',
    event_label: plan,
  });
}

// -- FAQ --

export function trackFaqToggle(question: string, action: 'open' | 'close'): void {
  trackEvent('faq_toggle', {
    event_category: 'engagement',
    event_label: question,
    action,
  });
}

// -- Navigation --

export function trackNavClick(linkText: string, destination: string): void {
  trackEvent('nav_click', {
    event_category: 'navigation',
    event_label: linkText,
    destination,
  });
}

// -- Scroll depth --

export function trackScrollDepth(threshold: 25 | 50 | 75 | 100): void {
  trackEvent('scroll_depth', {
    event_category: 'engagement',
    event_label: `${threshold}%`,
    percent_scrolled: threshold,
  });
}
